/**
 * Preserve Soren sheet reopen + deep-link context (from=soren).
 * Module memory only — survives in-SPA navigations, not full reloads.
 */

let reopenRequested = false
let savedScroll = 0

export function appendSorenSource(href: string): string {
  if (!href) return href
  if (/[?&]from=soren(?:&|$)/.test(href) || /[?&]sourceContext=soren(?:&|$)/.test(href)) {
    return href
  }
  return href.includes('?') ? `${href}&from=soren` : `${href}?from=soren`
}

export function isFromSoren(search: string | URLSearchParams): boolean {
  const params =
    typeof search === 'string' ? new URLSearchParams(search.replace(/^\?/, '')) : search
  const from = (params.get('from') || params.get('sourceContext') || '').toLowerCase()
  return from === 'soren'
}

export function requestSorenReopen(scrollTop = 0): void {
  reopenRequested = true
  savedScroll = scrollTop
}

export function consumeSorenReopen(): { reopen: boolean; scrollTop: number } {
  const reopen = reopenRequested
  const scrollTop = savedScroll
  reopenRequested = false
  savedScroll = 0
  return { reopen, scrollTop }
}

/** Test helper */
export function resetSorenSessionForTests(): void {
  reopenRequested = false
  savedScroll = 0
}
